export const isSubscriptionEndingNotifiedLimit3 = localStorage.getItem("subscription_ending_notified_limit_3")

export const isSubscriptionEndingNotifiedLimit1 = localStorage.getItem("subscription_ending_notified_limit_1")


export const setSubscriptionEndingLimit3 = () => {
    localStorage.setItem("subscription_ending_notified_limit_3", 'true');
};

export const setSubscriptionEndingLimit1 = () => {
    localStorage.setItem("subscription_ending_notified_limit_1", 'true');
};

export const removeSubscriptionEndingLimits = () => {
    localStorage.removeItem("subscription_ending_notified_limit_1");
    localStorage.removeItem("subscription_ending_notified_limit_3");
};